import { create } from "zustand";

type OpenModal<T = any> = (name: string, data?: T) => void;

interface IModalState {
  modal: { isOpen: boolean; modalName: string; data?: any };
  openModal: OpenModal;
  closeModal: () => void;
}

export const useModalStore = create<IModalState>((set) => ({
  modal: { isOpen: false, modalName: "", data: {} },
  openModal: (val, data) =>
    set(() => {
      return { modal: { isOpen: true, modalName: val, data } };
    }),
  closeModal: () => set({ modal: { isOpen: false, modalName: "", data: {} } }),
}));
